export default function roundNum(num) {
    if(!num) return "-"
    return +(Math.round(num + "e+6")  + "e-6");
}